import { viewerRegistry } from './ViewerRegistry';
import {
  PDFViewer,
  pdfMatcher,
  ImageViewer,
  imageMatcher,
  UnsupportedViewer,
  unsupportedMatcher,
} from './viewers';

/**
 * Registers default viewers
 * Should be called once at app initialization
 */
export function registerDefaultViewers(): void {
  // Register PDF viewer (high priority)
  viewerRegistry.register({
    id: 'pdf-viewer',
    priority: 100,
    matcher: pdfMatcher,
    component: PDFViewer,
  });

  // Register image viewer (medium priority)
  viewerRegistry.register({
    id: 'image-viewer',
    priority: 50,
    matcher: imageMatcher,
    component: ImageViewer,
  });

  // Register unsupported viewer (lowest priority - fallback)
  viewerRegistry.register({
    id: 'unsupported-viewer',
    priority: -1,
    matcher: unsupportedMatcher,
    component: UnsupportedViewer,
  });
}

// Auto-register on import (can be disabled if needed)
registerDefaultViewers();
